import { AlertTriangle, Check, Copy } from "lucide-react";

interface OAuthClientSecretModalProps {
  secret: string;
  onClose: () => void;
  onCopy: (value: string) => void;
}

export function OAuthClientSecretModal({ secret, onClose, onCopy }: Readonly<OAuthClientSecretModalProps>) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-lg rounded-lg bg-surface-secondary border border-border-primary p-6">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-yellow-400 shrink-0 mt-0.5" />
          <div className="min-w-0">
            <h3 className="font-semibold text-content-primary">Copy the client secret now</h3>
            <p className="text-sm text-content-tertiary mt-1">
              This is the only time the secret is shown. Store it securely — it can't be retrieved later.
            </p>
            <div className="mt-3 flex items-center gap-2 rounded bg-surface-primary p-2 font-mono no-ligatures text-xs text-content-primary break-all">
              {secret}
              <button type="button" onClick={() => onCopy(secret)} className="ml-auto shrink-0">
                <Copy className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
        <div className="mt-5 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="flex items-center gap-1.5 px-3 py-2 rounded-md bg-brand-primary text-white text-sm"
          >
            <Check className="h-4 w-4" /> I've saved it
          </button>
        </div>
      </div>
    </div>
  );
}
